import Siderbar from "./Siderbar";
import { getMenuItems } from "../config/sidebarMenuOptions";
import { useSelector } from "react-redux";
import { Navigate, Link } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
// `fullScreen` routes (e.g. the Workflow Builder) render without the app's
// sidebar and top bar.
const PrivateRoute = ({ element, roles, isLoggedIn, permission, fullScreen }) => {
  const { user, hasExpiredSubscription } = useSelector((state) => state.user);
  if (!isLoggedIn) {
    return <Navigate to="/portal/login" />;
  }

  if (permission) {
    if (
      !user?.permissions?.includes(permission) &&
      user?.role !== "super_admin"
    ) {
      return <Navigate to="/portal/dashboard" replace />;
    }
  }

  if (fullScreen) {
    return <div className="h-screen w-screen overflow-hidden">{element}</div>;
  }

  return (
    <div className="w-full h-full flex">
      <Siderbar menuItems={getMenuItems(user)} />
      <div className="flex flex-col flex-1 overflow-hidden">
        <div className="bg-[#FAFAFA] h-[75px] border-b border-gray-300 fixed top-0 left-0 right-0 z-10 ">
          {hasExpiredSubscription && (
            <div className=" text-red-800 text-center w-full h-full flex items-center justify-end px-2 sm:px-8">
              <div className="flex items-center gap-1 sm:gap-4">
                <LockKeyhole className="sm:mr-2" />
                Subscription expired
              </div>
              <Link
                className="ml-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
                to={"/portal/account"}
              >
                Renew Now
              </Link>
            </div>
          )}
        </div>
        <main className="flex-1 p-2 overflow-hidden mt-[75px]">{element}</main>
      </div>
    </div>
  );
};

export default PrivateRoute;
